/**
 * Copy da entrada/saída por voz do composer (§6.5 do CLAUDE.md do módulo).
 * Vive ao lado do componente porque `constants/TextChat.js` (o `COMPOSER_CHAT`)
 * é de outro dono — o destino final destas chaves é lá.
 */
export const COPY_VOZ = Object.freeze({
  escutando: 'Escutando...',
  iniciarVoz: 'Iniciar modo de voz',
  pararIa: 'Parar a IA de falar',
  ditar: 'Ditar',
  sairDoModoDeVoz: 'Sair do Modo de Voz',
  mutarMicrofone: 'Mutar microfone',
  reativarMicrofone: 'Reativar microfone',
  pararEEnviar: 'Parar e enviar',
  pararEEnviarDica: 'Parar e enviar (Esc cancela)',
  cancelarDitado: 'Cancelar ditado',
  cancelarDitadoDica: 'Cancelar ditado (Esc)',
  concluirDitado: 'Concluir ditado',
  erroTranscricao: 'Não foi possível transcrever o áudio.',
  semSuporteAudio: 'Este navegador não grava áudio. Digite sua pergunta normalmente.',
})

/**
 * [spec-008 T030c] A copy da sessão de voz em TEMPO REAL.
 *
 * ⚠️ **Nenhuma destas linhas carrega valor de negócio** (D-13/N16): a voz
 * REMETE ao cartão e a tela é que mostra cliente, ativo, valor e data-base.
 * "Uma decisão está esperando no cartão" é remissão; "confirmar o resgate de
 * R$ 120 mil da Ana" seria o canal falado carregando dado — o mesmo canal que
 * altera identificador em 6 de 11 medições (G-11).
 *
 * ⚠️ Também sem motivo técnico (N7): o motivo nomeado da queda vai para a
 * medição (`marcarFalhaDaMedicao`), nunca para a cara do consultor.
 */
export const COPY_VOZ_TEMPO_REAL = Object.freeze({
  // O rótulo da transcrição em curso — dito uma vez, acima do texto.
  vocEstaFalando: 'Você disse',
  // O cartão que espera decisão. Sem "clique aqui": quem desenha o cartão é a
  // conversa, e a linha do composer só avisa que ele existe.
  propostaAguardando: 'Uma decisão está esperando no cartão desta conversa.',
  // [T035] O aviso ANTES do corte. Os segundos vêm do ledger do provedor.
  avisoDeEncerramento: (segundos) =>
    `A sessão de voz encerra em cerca de ${Math.max(1, Math.round(Number(segundos) || 0))} s.`,
})
